import React, { useState } from 'react'
import ExpandMoreIcon from '@material-ui/icons/ExpandMoreRounded'
import ExpandLessIcon from '@material-ui/icons/ExpandLessRounded'
import styled from '@emotion/styled'

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  height: 41px;
  align-items: center;
`

const Title = styled.p`
  color: #3e3f42;
`

const TopText = styled.p`
  display: flex;
  color: #3e3f42;
`

const DataContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 41px;
  padding: 0 36px 0 12px;
  align-items: center;
  background-color: #f6f9fd;
  margin-bottom: 2px;
`

const StyledExpandLessIcon = styled(ExpandLessIcon)`
  margin-left: 12px;
`
const StyledExpandMoreIcon = styled(ExpandMoreIcon)`
  margin-left: 12px;
`

const ExpandableLine = ({
  title,
  text,
  data,
  renderExpandedTitle,
  renderExpandedText,
  renderDriverText,
  renderDriverExpandedText,
  driverId
}) => {
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <Container>
        <div>
          <Title>{title}</Title>
        </div>
        <div>
          <TopText>
            {renderDriverText ? renderDriverText(driverId) : text}
            {expanded ? (
              <StyledExpandLessIcon onClick={() => setExpanded(false)} />
            ) : (
              <StyledExpandMoreIcon onClick={() => setExpanded(true)} />
            )}
          </TopText>
        </div>
      </Container>
      {expanded && (
        <>
          {data.map(item => (
            <DataContainer>
              <div>
                <p>{renderExpandedTitle(item)}</p>
              </div>
              <div>
                <p>
                  {renderExpandedText
                    ? renderExpandedText(item)
                    : renderDriverExpandedText(item, driverId)}
                </p>
              </div>
            </DataContainer>
          ))}
        </>
      )}
    </>
  )
}
export default ExpandableLine
